import script from "./Affiliates.vue?vue&type=script&setup=true&lang=js"
export * from "./Affiliates.vue?vue&type=script&setup=true&lang=js"

import "./Affiliates.vue?vue&type=style&index=0&id=639b0847&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-639b0847"]])

export default __exports__